import authInstance from "../Interceptor/interceptor";

export const addRoleEffect = (formData) => {
    return authInstance.post("/roles/insertroles", formData);
};

export const deleteRoleEffect = (id) => {

    return authInstance.delete(`/roles/deleteroles/${id}`);
};
export const editRoleEffect = (id, formData) => {

    return authInstance.put(`/roles/updateRoles/${id}`, formData);
};
export const ViewRoleEffect = () => {
    return authInstance.get("/Role/list");
};

export const listRoleEffect = (pageNo) => {

    return authInstance.get(`/roles/getroles?pageNo=${pageNo}&pagesize=1&pagination_required=true`);
};

export const listAllRoleEffect = () => {

    return authInstance.get(`/roles/getroles?pageNo=1&pagesize=1&pagination_required=false`);
};